import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { useMe } from "../../../../swr";
import PasswordLoginSection from "../components/login/PasswordLoginSection";
import LoginSharedActions from "../components/login/LoginSharedActions";
import AuthShell from "../../routes/auth-shell";
import OtpLoginSection from "../components/login/OtpLoginSection";
import { DemoAccountPicker } from "../components/login/DemoAccountPicker";
import { dashboardRouteForRole, resolvePostLoginRedirect } from "../../utils/post-login-redirect";

type LoginMode = "password" | "otp";

const LOGIN_TABS = [
  { value: "password", label: "Email sign in" },
  { value: "otp", label: "Phone sign in" },
] as const;

function modeFromParams(params: URLSearchParams): LoginMode {
  return params.get("method") === "phone" ? "otp" : "password";
}

export function LoginPage() {
  const { user } = useMe();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const mode = modeFromParams(searchParams);

  const setMode = (next: LoginMode) => {
    setSearchParams(
      next === "otp" ? { method: "phone" } : {},
      { replace: true },
    );
  };

  if (user) return <Navigate to={resolvePostLoginRedirect(location, dashboardRouteForRole(user.role))} />;

  const isPasswordLogin = mode === "password";

  return (
    <AuthShell
      title="Sign in"
      tabs={{
        ariaLabel: "Sign in method",
        options: LOGIN_TABS,
        value: mode,
        onChange: setMode,
      }}
    >
      {isPasswordLogin ? <PasswordLoginSection /> : <OtpLoginSection />}
      <LoginSharedActions isPasswordLogin={isPasswordLogin} />
      <DemoAccountPicker />
    </AuthShell>
  );
}

export default LoginPage;
